import { createReducer } from 'redux-starter-kit';
import { handleError } from '../../utils/handleError';
import i18next from 'i18next';
import { ReportsPageApi } from './ReportsPageApi';
import Notice from '../../utils/Notice';
/**
 * Constants
 */

export const reportsPageModule = 'reportsPage';
const LOADING = `${reportsPageModule}/LOADING`;
const LIST_EMAIL_DATA = `${reportsPageModule}/LIST_EMAIL_DATA`;
const CLEAR_STATE = `${reportsPageModule}/CLEAR_STATE`;
const LOADING_DELETE_EMAIL = `${reportsPageModule}/LOADING_DELETE_EMAIL`;
const LOADING_ADD_EMAIL = `${reportsPageModule}/LOADING_ADD_EMAIL`;
const LIST_FINCENTER_ACTS = `${reportsPageModule}/LIST_FINCENTER_ACTS`;
const LOADING_FINCENTER_ACTS = `${reportsPageModule}/LOADING_FINCENTER_ACTS`;
const LOADING_FINCENTER_ACT = `${reportsPageModule}/LOADING_FINCENTER_ACT`;
const FINCENTER_ACT_BY_ID = `${reportsPageModule}/FINCENTER_ACT_BY_ID`;



/**
 * Reducer
 */

const initialState = {
  loading: false,
  loadingDeleteEmail: false,
  loadingAddEmail: false,
  emailList: {
    content: [],
    totalElements: 0,
  },
  loadingFincenterActs: false,
  reportFincenterActs: {
    content: [],
    totalElements: 0,
  },
  loadingFincenterAct: false,
  fincenterAct: null,
};

export default createReducer(initialState, {
  [LOADING]: (state, action) => {
    state.loading = action.payload;
  },
  [LIST_EMAIL_DATA]: (state, action) => {
    const filter = action.filter || {};
    if (filter.pageNumber && filter.pageNumber !== 1) {
      state.emailList.content = [
        ...state.emailList.content,
        ...action.payload.content,
      ];
    } else {
      state.emailList = action.payload;
    }
  },
  [LOADING_DELETE_EMAIL]: (state, action) => {
    state.loadingDeleteEmail = action.payload;
  },
  [LOADING_ADD_EMAIL]: (state, action) => {
    state.loadingAddEmail = action.payload;
  },
  [LOADING_FINCENTER_ACTS]: (state, action) => {
    state.loadingFincenterActs = action.payload;
  },
  [LIST_FINCENTER_ACTS]: (state, action) => {
    state.reportFincenterActs = action.payload;
  },
  [LOADING_FINCENTER_ACT]: (state, action) => {
    state.loadingFincenterAct = action.payload;
  },
  [FINCENTER_ACT_BY_ID]: (state, action) => {
    state.fincenterAct = action.payload;
  },
  [CLEAR_STATE]: () => initialState
});

/**
 * Actions
 */

export const clearState = () => ({ type: CLEAR_STATE });

export const loadEmailList = ({ filter }) => async dispatch => {
  try {
    dispatch({ type: LOADING, payload: true });
    const { data } = await ReportsPageApi.loadEmailList(JSON.stringify(filter));
    dispatch({
      type: LIST_EMAIL_DATA,
      payload: data.result,
      filter,
    });
  } catch (error) {
    handleError(error, i18next.t('reportsPage_errorLoadEmailList'));
  } finally {
    dispatch({ type: LOADING, payload: false });
  }
};

export const deleteEmail = (data, reloadPage, closeModal) => async dispatch => {
  dispatch({ type: LOADING_DELETE_EMAIL, payload: true });
  try {
    const response = await ReportsPageApi.deleteEmail(data);
    if (response.data.status === 'SUCCESS') {
      reloadPage();
      closeModal();
    } else {
      handleError(response, i18next.t('reportsPage_errorDeleteEmail'));
    }
  } catch (error) {
    handleError(error, i18next.t('reportsPage_errorDeleteEmail'));
  } finally {
    dispatch({ type: LOADING_DELETE_EMAIL, payload: false });
  }
};
export const addEmail = (email, reloadPage, closeModal) => async dispatch => {
  dispatch({ type: LOADING_ADD_EMAIL, payload: true });
  try {
    const response = await ReportsPageApi.addEmail(email);
    if (response.data.status === 'SUCCESS') {
      reloadPage();
      closeModal();
    } else {
      handleError(response, i18next.t('reportsPage_errorAddEmail'));
    }
  } catch (error) {
    handleError(error, i18next.t('reportsPage_errorAddEmail'));
  } finally {
    dispatch({ type: LOADING_ADD_EMAIL, payload: false });
  }
};

export const loadFincenterActs = (year) => async (dispatch, getState) => {
  try {
    dispatch({ type: LOADING_FINCENTER_ACTS, payload: true });

    const user = getState().login.user;
    const serviceProviderId = user?.organization_id;

    const { data } = await ReportsPageApi.loadReportFincenterActs(
      serviceProviderId,
      year
    );

    if (data.status === 'SUCCESS') {
      const acts = data.result || [];
      dispatch({
        type: LIST_FINCENTER_ACTS,
        payload: {
          content: acts,
          totalElements: acts.length,
        },
      });
    } else {
      handleError(data, i18next.t('reportsPage_errorLoadFincenterActs'));
    }
  } catch (error) {
    handleError(error, i18next.t('reportsPage_errorLoadFincenterActs'));
  } finally {
    dispatch({ type: LOADING_FINCENTER_ACTS, payload: false });
  }
};

const downloadPDF = (data, fileName) => {
  const blob = new Blob([data], { type: 'application/pdf' }); // указываем тип PDF
  const url = window.URL.createObjectURL(blob);

  const element = document.createElement('a');
  element.href = url;
  element.download = fileName.endsWith('.pdf') ? fileName : `${fileName}.pdf`;
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);

  window.URL.revokeObjectURL(url);
};

export const exportFincenterAct = (documentId) => async (dispatch) => {
  dispatch({ type: LOADING_FINCENTER_ACTS, payload: true });

  try {
    const response = await ReportsPageApi.exportFincenterAct(documentId);
    if (response && response.data) {
      downloadPDF(response.data, `fincenterAct_${documentId}`);
      Notice.success(i18next.t('reportsPage_fincenterSuccessDownload'));
    }
  } catch (error) {
    handleError(error, i18next.t('reportsPage_fincenterErrorDownload'));
  } finally {
    dispatch({ type: LOADING_FINCENTER_ACTS, payload: false });
  }
};

export const loadFincenterActById = (id) => async (dispatch) => {
  dispatch({ type: LOADING_FINCENTER_ACT, payload: true });
  try {
    const response = await ReportsPageApi.loadFincenterActById(id);

    if (response?.data?.status === 'SUCCESS') {
      dispatch({
        type: FINCENTER_ACT_BY_ID,
        payload: response.data.result || null,
      });
    } else {
      handleError(response, i18next.t('reportsPage_errorLoadFincenterActById'));
    }
  } catch (error) {
    handleError(error, i18next.t('reportsPage_errorLoadFincenterActById'));
  } finally {
    dispatch({ type: LOADING_FINCENTER_ACT, payload: false });
  }
};

export const generateFincenterAct = (history) => async (dispatch, getState) => {
  try {
    dispatch({ type: LOADING_FINCENTER_ACTS, payload: true });

    const user = getState().login.user;
    const serviceProviderId = user?.organization_id;

    if (!serviceProviderId) {
      Notice.error(i18next.t('reportsPage_errorGenerateFincenterAct'));
      return;
    }

    const response = await ReportsPageApi.generateFincenterAct(serviceProviderId);
    if (response?.data) {

      const generatedAct = response.data;

      Notice.success(i18next.t('reportsPage_fincenterSuccessGenerate'));
      if (history && generatedAct?.id) {
        history.push(`/fincenter-act/${generatedAct.id}`);
      }

    } else {
      handleError(response, i18next.t('reportsPage_errorGenerateFincenterAct'));
    }

  } catch (error) {
    handleError(error, i18next.t('reportsPage_errorGenerateFincenterAct'));
  } finally {
    dispatch({ type: LOADING_FINCENTER_ACTS, payload: false });
  }
};


